<template>
  <button
    v-if="width > tabSize"
    :class="['button-menu-mobile', open ? 'open' : '']"
    v-on:click="clickHandler"
  >
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </button>
  <button
    v-else
    v-b-toggle.drawer
    :class="['button-menu-mobile', open ? '' : 'open']"
    v-on:click="clickHandler"
  >
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </button>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TOGGLE_SIDEBAR, TAB_SIZE } from "@/store/mutation-types";
export default {
  name: "HamberButton",
  data() {
    return {
      tabSize: TAB_SIZE
    };
  },
  computed: {
    ...mapState("setting", ["open", "width"])
  },
  methods: {
    clickHandler: function() {
      if (this.open) {
        this[TOGGLE_SIDEBAR](false);
      } else {
        this[TOGGLE_SIDEBAR](true);
      }
    },
    ...mapActions("setting", [TOGGLE_SIDEBAR])
  }
};
</script>

<style lang="scss">
.button-menu-mobile {
  width: 26px;
  height: 20px;
  padding: 0;
  border: none;
  margin-left: 10px;
  background: transparent;
  position: relative;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  span {
    display: block;
    position: absolute;
    height: 4px;
    width: 50%;
    background: rgba(255, 255, 255, 0.5);
    opacity: 1;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.25s ease-in-out;
    -moz-transition: 0.25s ease-in-out;
    -o-transition: 0.25s ease-in-out;
    transition: 0.25s ease-in-out;

    &:nth-child(even) {
      left: 50%;
      border-radius: 0 5px 5px 0;
    }

    &:nth-child(odd) {
      left: 0px;
      border-radius: 5px 0 0 5px;
    }
    &:nth-child(1),
    &:nth-child(2) {
      top: 0px;
    }

    &:nth-child(3),
    &:nth-child(4) {
      top: 8px;
    }

    &:nth-child(5),
    &:nth-child(6) {
      top: 16px;
    }
  }
  &.open span {
    background: rgb(255, 255, 255);
    &:nth-child(1),
    &:nth-child(6) {
      -webkit-transform: rotate(45deg);
      -moz-transform: rotate(45deg);
      -o-transform: rotate(45deg);
      transform: rotate(45deg);
    }
    &:nth-child(2),
    &:nth-child(5) {
      -webkit-transform: rotate(-45deg);
      -moz-transform: rotate(-45deg);
      -o-transform: rotate(-45deg);
      transform: rotate(-45deg);
    }
    &:nth-child(1) {
      left: 2px;
      top: 4px;
    }
    &:nth-child(2) {
      left: calc(50% - 2px);
      top: 4px;
    }
    &:nth-child(3) {
      left: -50%;
      opacity: 0;
    }
    &:nth-child(4) {
      left: 100%;
      opacity: 0;
    }
    &:nth-child(5) {
      left: 2px;
      top: 13px;
    }
    &:nth-child(6) {
      left: calc(50% - 2px);
      top: 13px;
    }
  }
}
</style>
